import { useEffect } from "react";

import { PreloadedQuery, usePreloadedQuery } from "react-relay";
import {
    AnchorPageRelayQuery,
    shapeAnchorContentfulResponse
} from "src/contentful";

import { anchorPageRelayQuery } from "@/__generated_contentful__/anchorPageRelayQuery.graphql";
import { AnchorContentsResponse } from "@/utils/anchor-queries/get-anchor-contents";
import { experiments, useExperimentExposure } from "@/utils/experiment";

import { JiraSoftwarePageProps } from "./jira-software-page";
import { JiraSoftwarePagePaidLpJswAnchor } from "./paid-lp-jsw-anchor";

export interface JiraSoftwarePagePaidLpJswCompetitorsRelayProps
    extends JiraSoftwarePageProps {
    anchorContents?: AnchorContentsResponse | null;
    persona?: string;
    queryRef?: PreloadedQuery<anchorPageRelayQuery>;
}

export const JiraSoftwarePagePaidLpJswCompetitorsRelay = (
    pageProps: JiraSoftwarePagePaidLpJswCompetitorsRelayProps
) => {
    const [cpapiDeprecationExposureFired, fireCpapiDeprecationExposure] =
        useExperimentExposure(experiments.cpapiDeprecationJiraExperiment);

    useEffect(() => {
        if (!cpapiDeprecationExposureFired) {
            fireCpapiDeprecationExposure();
        }
    }, [cpapiDeprecationExposureFired, fireCpapiDeprecationExposure]);
    const data = usePreloadedQuery(
        AnchorPageRelayQuery,
        pageProps.queryRef ||
            (null as unknown as PreloadedQuery<anchorPageRelayQuery>)
    );

    return (
        <JiraSoftwarePagePaidLpJswAnchor
            {...pageProps}
            anchorContents={shapeAnchorContentfulResponse(data)}
            pageId="paid-lp-jsw-competitors"
            persona="unknown"
            pageVariant="competitors"
        />
    );
};
